import { render, staticRenderFns } from "./ImageCategoryPromo.vue?vue&type=template&id=1dbf57a0&"
import script from "./ImageCategoryPromo.vue?vue&type=script&lang=js&"
export * from "./ImageCategoryPromo.vue?vue&type=script&lang=js&"
import style0 from "./ImageCategoryPromo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VContainer,VFlex,VLayout,VSkeletonLoader})
